import { isDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';

import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';

type OrderSpotProps = {
  spotDate:
    | {
        spot: number | undefined;
        digitCount: number | undefined;
      }
    | undefined;
};

export const OrderSpot = ({ spotDate }: OrderSpotProps) => {
  const { spot, digitCount } = spotDate ?? {};

  return (
    <OrderRow labelId="order.fields.spot.label">
      {isDefined(spot) && <FormattedNumber value={spot} minimumFractionDigits={digitCount} />}
    </OrderRow>
  );
};
